import React from 'react';
import { Provider } from 'react-redux';
import configureStore from '../store/findBobPublicStore';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import client from '../lib/apolloClient';
import { SnackbarProvider } from 'notistack';
import getMessages from '../lib/i18n/getMessages';
import { CurrencyProvider } from '../hooks/useCurrency';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import ValueAccelerationCategoryPage from '../components/Succession/ValueAcceleration/ValueAccelerationCategoryPage';

const ValueAccelerationCategoryPageContainer = (props, railsContext) => {
  const mergedCompany = props.company
    ? { ...props.company, feature_types: (props.company.feature_types || props.features || []), features: (props.company.features || props.features || []) }
    : {
      host: railsContext && railsContext.company_host,
      features: (railsContext && railsContext.features) || [],
      file_import_disclaimer: railsContext && railsContext.file_import_disclaimer,
      name: railsContext && railsContext.company_name,
      branded_name: railsContext && railsContext.company_branded_name,
      short_name: railsContext && railsContext.company_short_name,
    };

  const initialState = {
    company: mergedCompany,
    user: props.current_user,
    intl: { locale: (railsContext && railsContext.i18nLocale) || 'en' },
  };

  const store = configureStore(initialState);
  if (typeof document !== 'undefined') {
    document.store = store;
  }

  window.locale = (railsContext && railsContext.i18nLocale) || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  const locale = window.locale;
  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <Provider store={store}>
        <ApolloProvider client={client}>
          <IntlProvider locale={locale} messages={getMessages(locale)}>
            <SnackbarProvider maxSnack={3}>
              <SuccessionThemeProvider company={mergedCompany} user={props.current_user}>
                <div className="bg-succession-bg-secondary min-h-screen">
                  <ValueAccelerationCategoryPage {...props} />
                </div>
              </SuccessionThemeProvider>
            </SnackbarProvider>
          </IntlProvider>
        </ApolloProvider>
      </Provider>
    </CurrencyProvider>
  );
};

export default ValueAccelerationCategoryPageContainer;


